// extracted by mini-css-extract-plugin
export default {"path":"path-QR31","icon":"icon-uJio"};